/* eslint-disable max-classes-per-file */
export class CreateSkogsvard {
    kontraktCopyGuid: string;
    atgardCopyGuid: string;
    atgardCopyId?: number;
    copyContractGeometries: boolean;
    skogsvardRowTypes: SkogsVardRowType[];

    constructor() {
        this.kontraktCopyGuid = undefined;
        this.atgardCopyGuid = undefined;
        this.skogsvardRowTypes = [];
        this.addRow();
    }
    addRow() {
        this.skogsvardRowTypes.push(new SkogsVardRowType());
    }
}
export class SkogsVardRowType {
    skogsvardGrupp: string;
    skogsvardTyp: string;
}

export class SkogsvardSelectAtgardItem {
    kontraktGuid: string;
    atgardId?: number;
    value: string;
    grupp: string;
    text: string;
    index: number;
    isSkogsvard: boolean;

    constructor(kontraktGuid: string, atgardId: number, value: string, grupp: string, text: string, index: number, isSkogsvard: boolean) {
        this.kontraktGuid = kontraktGuid;
        this.atgardId = atgardId;
        this.value = value;
        this.grupp = grupp;
        this.text = text;
        this.index = index;
        this.isSkogsvard = isSkogsvard;
    }
}
